export default "__VITE_ASSET__BKfZL7ly__"